import { CheckCircle2 } from "lucide-react";

const STEPS = [
  {
    num: "01",
    title: "Connect your Deriv account",
    desc: "Sign up or log in with one click. We use Deriv's official OAuth — your credentials never touch our servers.",
    bullets: ["No password required", "Secure OAuth handshake", "Demo or real account"],
  },
  {
    num: "02",
    title: "Explore markets in real time",
    desc: "Browse 100+ instruments with live tick streams. Beginner-friendly charts highlight key levels and trends.",
    bullets: ["Live WebSocket data", "Candlestick + line charts", "Multi-timeframe analysis"],
  },
  {
    num: "03",
    title: "Trade manually or run the bots — free",
    desc: "Fire Pro Trades with one click, play the Arcade, or switch on the 103-strategy Auto Bot and Over 3 Quick Bot — they keep trading 24/7 on our servers. All of it is 100% free.",
    bullets: ["Everything free — no subscription", "24/7 server-side bots", "Smart-Secure profit lock"],
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative py-24 lg:py-32 border-t border-vts-line"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.25em] text-vts-blue font-semibold mb-4">
            02 — How VTS works
          </div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            From signup to first trade<br />
            <span className="text-vts-silver">in under 60 seconds.</span>
          </h2>
        </div>

        <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-px bg-vts-line">
          {STEPS.map((s, idx) => (
            <div
              key={s.num}
              data-testid={`how-step-${idx + 1}`}
              className="relative bg-vts-bg p-8 lg:p-10 group hover:bg-vts-surface transition"
            >
              <div className="flex items-baseline gap-4 mb-6">
                <span className="font-mono text-vts-blue text-sm font-semibold tabular-nums">
                  {s.num}
                </span>
                <div className="flex-1 h-px bg-vts-line group-hover:bg-vts-blue/40 transition" />
              </div>
              <h3 className="font-heading font-semibold text-2xl text-white mb-3 tracking-tight">
                {s.title}
              </h3>
              <p className="text-vts-silver/70 text-sm leading-relaxed mb-7 font-body">
                {s.desc}
              </p>
              <ul className="space-y-2.5">
                {s.bullets.map((b) => (
                  <li
                    key={b}
                    className="flex items-center gap-2.5 text-sm text-vts-silver"
                  >
                    <CheckCircle2 className="h-4 w-4 text-vts-blue shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
